import { useSessionStore } from '@hub/hooks/states/useSessionStore';
import { useEffect, useState } from 'react';

export const useCartArticleCount = () => {
  const session = useSessionStore(state => state.session);
  const [cartArticleCount, setCartArticleCount] = useState(0);

  useEffect(() => {
    if (!session) {
      return;
    }
    setCartArticleCount(session.cartArticleCount);
  }, [session]);

  return cartArticleCount;
};
